import React, { useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

import Window from 'components/dialog/Window'

import colors from './colors'

import {
  DEFAULT_PROJECT_SETTINGS,
} from '../../settings'

const getColorStyle = color => ({
  backgroundColor: colors[color],
})

const useStyles = makeStyles(theme => {
  return {
    cell: {
      padding: theme.spacing(2),
    },
    textField: {
      width: '100%',
    },
    color: {
      width: '50px',
      height: '50px',
      border: '1px solid #000',
    },
    red: getColorStyle('red'),
    amber: getColorStyle('amber'),
    green: getColorStyle('green'),
  }
})

const SettingsEditorItem = ({
  value,
  color,
  onChange,
}) => {
  const classes = useStyles()
  return (
    <Grid container>
      <Grid item xs={ 4 } className={ classes.cell }>
        <Typography>
          { color }
        </Typography>
      </Grid>
      <Grid item xs={ 4 } className={ classes.cell }>
        <TextField
          id="item-text"
          label="Threshold"
          variant="outlined"
          type="number"
          value={ value }
          className={ classes.textField }
          onChange={ (e) => onChange(e.target.value) }
        />
      </Grid>
      <Grid item xs={ 4 } className={ classes.cell }>
        <div className={ classnames(classes.color, classes[color]) }>

        </div>
      </Grid>
    </Grid>
  )
}

const processValues = values => Object.keys(values).reduce((all, key) => {
  all[key] = parseInt(values[key])
  return all
}, {})

const SettingsEditor = ({
  initialValues,
  onClose,
  onSubmit,
}) => {
  const classes = useStyles()
  const [ values, setValues ] = useState(initialValues || DEFAULT_PROJECT_SETTINGS)
  
  const setColor = (color, value) => {
    const newValues = Object.assign({}, values, {
      [color]: value,
    })
    setValues(newValues)
  }

  const onSave = useCallback(() => {
    if(!onSubmit) return
    onSubmit(processValues(values))
  }, [
    values
  ])

  const hasError = Object.keys(values).find(key => {
    return isNaN(parseInt(values[key]))
  })

  return (
    <Window
      open
      size="md"
      title="Project Settings"
      cancelTitle="Cancel"
      submitTitle="Save"
      withCancel
      disabled={ hasError }
      onCancel={ onClose }
      onSubmit={ onSave }
    >
      <Grid container>
        <Grid item xs={ 12 } className={ classes.cell }>
          <Typography gutterBottom>
            To change the thresholds of colours - enter a value between 0 and 100.
          </Typography>
        </Grid>
      </Grid>
      <SettingsEditorItem
        value={ values.red }
        color="red"
        onChange={ value => setColor('red', value) }
      />
      <SettingsEditorItem
        value={ values.amber }
        color="amber"
        onChange={ value => setColor('amber', value) }
      />
      <SettingsEditorItem
        value={ values.green }
        color="green"
        onChange={ value => setColor('green', value) }
      />
      
    </Window>
  )
}

export default SettingsEditor